"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import homeIcon from "@/public/images/home.svg";
import leftArrowIcon from "@/public/images/leftArrow.svg";
import calendarIcon from "@/public/images/calendar.svg";
import facultyExistIcon from "@/public/images/facultyExist.svg";
import blackCapIcon from "@/public/images/blackCap.svg";
import viewIcon from "@/public/images/view.svg";
import timeIcon from "@/public/images/time.svg";
import latestIcon from "@/public/images/latest.svg";
import locationGreyIcon from "@/public/images/locationGrey.svg";
import FaviconIcon from "@/public/Favicon.svg";
import fireIcon from "@/public/images/fire.svg";
import ShowImage from "@/public/icons/ShoImage.svg";
import { format } from "date-fns";
import { ar, enUS } from "date-fns/locale";
import { University } from "@/types/university";
import { DialogDemo } from "@/components/shared/Dialog/ImaageDialog";
import ShareButtons from "@/components/shared/ShareButtons";
import Link from "next/link";
import MyLink from "@/components/shared/myLink/MyLink";
import ImageNo from "@/public/images/no-image-icon-23492.png";
import ApplicationInformation from "./ApplicationInformation";
import {
  useAddToUniversitiesFavoritesMutation,
  useRemoveToUniversitiesFavoritesMutation,
} from "@/redux/features/api/Favorites/favoritesApiSlice";
import { toast } from "react-toastify";
import { formatNumber } from "@/utils/format viwes number/formatNumber";
import { getCookie } from "cookies-next";
interface HeaderSectionProps {
  university: University;
  locale: "ar" | "en";
}

const HeaderSection: React.FC<HeaderSectionProps> = ({
  university,
  locale,
}) => {
  const [isFavorite, setIsFavorite] = useState<any>(
    university?.favorite || false
  );
  const [addToFavorites, {}] = useAddToUniversitiesFavoritesMutation();
  const [removeToFavorites, {}] = useRemoveToUniversitiesFavoritesMutation();

  const handleAddToFavorites = async () => {
    const token = getCookie("token");
    if (token) {
      if (university) {
        try {
          await addToFavorites({ university_id: university.id }).unwrap();
          toast.success(
            locale === "ar"
              ? "تمت الاضافة الى المفضلات بنجاح"
              : "Added to favorites successfully"
          );
          setIsFavorite(true);
        } catch (error) {
          toast.error(locale === "ar" ? "حدث خطا ما " : "An error occurred");
          console.error("Error adding to favorites:", error);
        }
      }
    } else toast.error(locale === "ar" ? "يجب تسجيل الدخول" : "Please login");
  };
  const handleRemoveToFavorites = async () => {
    if (university) {
      try {
        await removeToFavorites({ university_id: university.id }).unwrap();
        toast.success(
          locale === "ar"
            ? "تم الحذف من المفضلات بنجاح"
            : "Removed from favorites successfully"
        );
        setIsFavorite(false);
      } catch (error) {
        toast.error(locale === "ar" ? "حدث خطا ما " : "An error occurred");
        console.error("Error adding to favorites:", error);
      }
    }
  };
  const {
    name,
    video_link,
    image,
    founding_date,
    faculties_count,
    specialization_count,
    short_description,
    viewing_number,
    // location,
    // current_branch,
    map_links,
    images,
    created_at,
    updated_at,
    contact_url,
  } = university;
  // const [openDiloag, setOpenDilog] = useState(false);

  const [show, setshow] = useState<string>(
    images.length > 0 ? images[0].image : ImageNo
  );
  const [bigImage, setbigImage] = useState<string>("");
  console.log({ viewing_number });
  useEffect(() => {
    if (images.length > 0 && show !== "video") {
      const interval = setInterval(() => {
        setshow((prevShow) => {
          const currentIndex = images.findIndex(
            (img) => img.image === prevShow
          );
          const nextIndex = (currentIndex + 1) % images.length;
          return images[nextIndex].image;
        });
      }, 3000);

      return () => clearInterval(interval); // Cleanup on unmount
    }
  }, [images, show]);

  // Format dates based on locale
  const formatDate = (dateString: string | undefined, locale: "ar" | "en") => {
    if (!dateString) return "0";
    const date = new Date(dateString);
    return format(date, "PPP", { locale: locale === "ar" ? ar : enUS });
  };

  return (
    <div className="container flex flex-wrap md:flex-nowrap items-center gap-5 relative bgLinear ">
      <div className=" md:min-w-[460px] w-full  md:max-w-[460px]  bg-white  rounded-[10px] p-4 flex items-center justify-center mx-auto flex-col gap-[10px]  h-fit lg:sticky lg:top-10">
        {show === "video" ? (
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${new URLSearchParams(
              new URL(video_link).search
            ).get("v")}`}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="max-w-[420px]  md:min-h-[172px] max-h-[172px] object-contain rounded-[10px]"
          ></iframe>
        ) : (
          <div className="relative max-w-[420px]  md:min-h-[172px] max-h-[172px] overflow-hidden ">
            <Image
              src={show}
              alt={`University Image`}
              className="w-full h-full object-cover rounded"
              width={300}
              height={300}
              loading="lazy"
            />
            <div
              onClick={() => setbigImage(show)}
              className="absolute top-5 right-5 w-[420px]  min-h-[172px] max-h-[172px]"
            >
              <DialogDemo
                open={<Image src={ShowImage} alt="Show Image" />}
                src={bigImage}
              />
            </div>
          </div>
        )}

        {images.length > 0 && (
          <div className="flex items-center gap-[10px] overflow-auto px-2 custom-scroll-bar">
            <div
              onClick={() => setshow("video")}
              style={{ cursor: "pointer" }}
              className="w-[97px] h-[61px] object-contain mb-3"
            >
              <iframe
                // style={
                //   bigImage === "video" ? { border: "4px solid #0099FF" } : {}
                // }
                width="164px"
                height="105px"
                src={`https://www.youtube.com/embed/${new URLSearchParams(
                  new URL(video_link).search
                ).get("v")}`}
                title="YouTube video player"
                allowFullScreen
                className="pointer-events-none w-[97px] h-[61px] rounded-lg mb-3"
              ></iframe>
            </div>

            {images.map((img, index) => {
              if (img.image) {
                return (
                  <Image
                    onClick={() => setshow(img.image)}
                    key={index}
                    src={img.image}
                    alt={`University Image ${index}`}
                    className="w-[97px] h-[61px] object-cover rounded-[10px] cursor-pointer mb-3"
                    style={
                      show == img.image ? { border: "2px solid #0099FF" } : {}
                    }
                    width={164}
                    height={105}
                    loading="lazy"
                  />
                );
              }
              return null;
            })}
          </div>
        )}

        <div className="grid grid-cols-3 gap-3">
          <div className="p-2 flex flex-col items-center justify-center gap-[5px] ">
            <Image src={calendarIcon} alt="Calendar Icon" />
            <p className="text-[14px] text-center text-darkText">
              {locale === "ar" ? "تأسيس الجامعة" : "Established"}
            </p>
            <p className="text-14 text-[#ACB5BB] font-[600]">{founding_date}</p>
          </div>
          <div className="p-2 flex flex-col  items-center justify-center gap-[5px] ">
            <Image src={facultyExistIcon} alt="Faculty Exist Icon" />
            <p className="text-[14px] text-center text-darkText">
              {locale === "ar" ? "الكليات الموجودة" : "Faculties"}
            </p>
            <p className="text-14 text-[#ACB5BB] font-[600]">
              + {faculties_count}
            </p>
          </div>
          <div className="p-2 flex flex-col items-center justify-center gap-[5px] ">
            <Image src={blackCapIcon} alt="Black Cap Icon" />
            <p className="text-14 text-center text-darkText">
              {locale === "ar" ? "تخصص" : "Program"}
            </p>
            <p className="text-14 text-[#ACB5BB] font-[600]">
              {specialization_count || "0"}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between w-full gap-3">
          <ApplicationInformation university={university}>
            <div className="bg-primaryColor py-3  rounded-[10px] text-20 text-white flex items-center justify-center flex-1">
              {locale === "ar" ? "معلومات التقديم" : "Application Information"}
            </div>
          </ApplicationInformation>

          <ShareButtons
            isFavorite={isFavorite}
            handleAddToFavorites={handleAddToFavorites}
            handleRemoveToFavorites={handleRemoveToFavorites}
            title={name[locale]}
          />
        </div>
      </div>
      <div className="grow flex w-full  flex-col gap-8">
        <div className="flex items-center gap-3">
          <MyLink href="/" className="flex items-center gap-1.5 hover:text-primaryColor transition-colors">
            <Image src={homeIcon} alt="Home Icon" />
            <span className="text-12 text-descriptionText hover:text-primaryColor transition-colors">
              {locale === "ar" ? "الرئيسية" : "Home"}
            </span>
          </MyLink>
          <Image src={leftArrowIcon} alt="Left Arrow Icon" />
          <MyLink href="/universities" className="hover:text-primaryColor transition-colors">
            <span className="text-12 text-descriptionText hover:text-primaryColor transition-colors">
              {locale === "ar" ? "الجامعات" : "Universities"}
            </span>
          </MyLink>
          <Image src={leftArrowIcon} alt="Left Arrow Icon" />
          <p className="text-12 text-descriptionText">{name[locale]}</p>
        </div>
        <div className="flex items-center gap-3">
          {image && (
            <Image
              src={image}
              alt="University Image"
              className="h-[96] object-contain"
              width={96}
              height={96}
            />
          )}
          <div>
            <p className="text-30 text-darkText font-[500]">{name[locale]}</p>
            <div className="flex items-center gap-3">
              <Image src={locationGreyIcon} alt="Location Grey Icon" />
              <p className="text-16 text-descriptionText">
                {map_links && map_links[0]?.title[locale]}
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between gap-5">
          <div className="flex items-center gap-3 flex-wrap">
            {university.nominate_it ? (
              <div className="bg-white py-2 px-7 rounded-full flex items-center gap-3">
                <Image src={FaviconIcon} alt="favicon" width={20} height={20} />
                <p className="text-14 text-darkText">
                  {locale === "ar" ? "نرشحها" : "recommend"}
                </p>
              </div>
            ) : (
              ""
            )}
            {university.trending_now || university.trending_now_for_all ? (
              <div className="bg-white py-2 px-7 rounded-full flex items-center gap-3">
                <Image src={fireIcon} alt="Fire Icon" />
                <p className="text-14 text-darkText">
                  {locale === "ar" ? "رائج الآن" : "Trending Now"}
                </p>
              </div>
            ) : (
              ""
            )}
          </div>
          <p className="text-14 text-darkText bg-white py-2 px-7 rounded-full">
            {university?.type[`name_${locale}`]}
          </p>
        </div>
        <p
          className="text-18 text-descriptionText"
          dangerouslySetInnerHTML={{ __html: short_description[locale] }}
        ></p>
        <div className="flex items-center justify-between gap-5 flex-wrap">
          <div className="flex items-center gap-5">
            <div className="flex items-center gap-3">
              <Image src={timeIcon} alt="Time Icon" />
              <div>
                <p className="text-16 text-darkText">
                  {locale === "ar" ? "تاريخ انشاء" : "Creation Date"}
                </p>
                <p className="text-14 text-descriptionText">
                  {formatDate(created_at, locale)}
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Image src={latestIcon} alt="Latest Icon" />
              <div>
                <p className="text-16 text-darkText">
                  {locale === "ar" ? "تاريخ التحديث" : "Latest Update"}{" "}
                </p>
                <p className="text-14 text-descriptionText">
                  {formatDate(updated_at, locale)}
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <Image src={viewIcon} alt="View Icon" />
            <p className="text-16 text-descriptionText font-[500]">
              {formatNumber(viewing_number)}{" "}
              {locale === "ar" ? "مشاهدة" : "Views"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
